import styled from 'styled-components';

import { ThemeProps as Prop, Components, Orientations } from '@powdr/constants';
import { themeUtil } from '@powdr/utils';

const CPNT = Components.PRODUCT_FINDER;

export const FiltersWrapper = styled.div`
  display: flex;
  background-color: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};
  width: 100%;
  padding: 25px;
  ${({ $orientation }) => (($orientation === Orientations.HORIZONTAL) ? `
    flex-direction: row;
    justify-content: space-between;
  ` : `
    flex-direction: column;
    justify-content: space-between;
  `)};
`;

export const CheckboxGroupWrapper = styled.div`
  ${({ $isHorizontalFilterLayout }) => (!$isHorizontalFilterLayout) && '&:not(:last-child) { margin-bottom: 50px; }'};
`;

export const CheckboxGroupHeader = styled.h2`
  color: ${({ $colorProfile }) => themeUtil(Prop.HEADER, CPNT, $colorProfile)};
  font-size: ${({ theme }) => theme.FontSize.MED30};
  line-height: normal;
  margin-bottom: 12px;
`;

export const CheckboxGroup = styled.ul``;

export const CheckboxWrapper = styled.li`
  margin-bottom: 12px;
`;
